var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "a",
    { staticClass: "search-preview", attrs: { href: _vm.props.item.url } },
    [
      _vm._m(0),
      _c("span", { staticClass: "search-preview__info" }, [
        _c("span", {
          staticClass: "search-preview__text",
          domProps: {
            innerHTML: _vm._s(
              _vm.props.fn(
                _vm.props.item.title,
                _vm.props.item.title,
                _vm.props.localsearch
              )
            )
          }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function(_h, _vm) {
    var _c = _vm._c
    return _c(
      "span",
      {
        staticClass: "search-preview__img-wrap search-preview__img-wrap--mini"
      },
      [
        _c("img", {
          staticClass: "search-preview__img",
          attrs: { src: "/static/images/page_preview.svg" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0945a51a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0945a51a","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/search/parts/pages.vue
// module id = 224
// module chunks = 4